import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import styles from './index.pcss';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import { getFeatureVariant } from '../../organism/ABFeature/Feature';
import { getShowRateProdBtn } from '../../selectors/featureFlagsSelector';

const isSignedIn = signInCheck();

const cx = classNames.bind(styles);
const mapStateToProps = state => ({
  showRateProdBtn: getShowRateProdBtn(state?.flags)
});
const connector = connect(mapStateToProps);

const UnrateItemsMobile = (props: any) => {
  const { rateProductModal, isRating, toggleOn, btnCta, isFleek = false } = props;
  const rateProdBtnVariant = getFeatureVariant('showRateProdBtnSection') || '0';
  const isWriteAReview = btnCta.toLowerCase() === 'write a review';
  console.log('UNRATE ITEMS', isFleek);
  return (
    <div className={cx('unrated-items-mobile', isFleek ? 'fleek-unrated-items-mobile' : '')}>
      {!isRating && (
        <div className={cx('unrated-text')}>
          <p className={cx('unrate-head')}>Ratings</p>
          <ul
            className={cx('No-rating-or-review-to-display-Be-the-first-one-to-review-this-product')}
          >
            <li>No rating or review to display. </li>
            {isSignedIn && <li>Be the first one to review this product</li>}
          </ul>
        </div>
      )}
      {/* TODO: change this experiment to 1 */}
      {isSignedIn && (
        <div className={cx('rate-btn-section')}>
          <div
            className={cx('rate-this-product')}
            style={{ margin: toggleOn ? '32px 0 0 0' : isRating ? '17px 0 0 0' : '' }}
            onClick={() => rateProductModal(isWriteAReview)}
          >
            <p className={cx('rate-this-btn')} >
              {btnCta}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default connector(UnrateItemsMobile);
